import {
  ROLE_LIST_REQUEST,
  ROLE_LIST_SUCCESS,
  ROLE_LIST_FAIL,
  MODULE_LIST_REQUEST,
  MODULE_LIST_SUCCESS,
  MODULE_LIST_FAIL,
  BULK_ACTION_REQUEST,
  BULK_ACTION_SUCCESS,
  BULK_ACTION_FAIL,
  CREATE_ROLE_REQUEST,
  CREATE_ROLE_SUCCESS,
  CREATE_ROLE_FAIL,
  DETAIL_ROLE_REQUEST,
  DETAIL_ROLE_SUCCESS,
  DETAIL_ROLE_FAIL,
  UPDATE_ROLE_REQUEST,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_FAIL,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_FAIL,
  RESET_STATE_ROLE
} from '../../constants/roles'

const initialState = {
  roles: [],
  modules: [],
  role: {},
  loading: false,
  loadingSummary: false,
  loadingBulkAction: false,
  status: '',
  error: ''
}

const roleReducer = (state = initialState, action) => {
  switch (action.type) {
    // ** Section List Role
    case ROLE_LIST_REQUEST:
      return { ...state, loading: true }
    case ROLE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        roles: action.payload
      }
    case ROLE_LIST_FAIL:
      return { ...state, loadingSummary: false, error: action.payload }
    case MODULE_LIST_REQUEST:
      return { ...state, loadingSummary: true }
    case MODULE_LIST_SUCCESS:
      return {
        ...state,
        loadingSummary: false,
        modules: action.payload
      }
    case MODULE_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
        // modules: dummy.data
      }

    // ** Section Create Role
    case CREATE_ROLE_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_ROLE_SUCCESS:
      const roleCreate = [...state?.roles]
      roleCreate.push(action.payload)

      return {
        ...state,
        roles: roleCreate,
        loadingCreate: false,
        status: 'success'
      }
    case CREATE_ROLE_FAIL:
      return {
        ...state,
        loadingCreate: false,
        status: 'error',
        error: action.payload
      }

    case BULK_ACTION_REQUEST:
      return { ...state, loadingBulkAction: true }
    case BULK_ACTION_SUCCESS:
      return {
        ...state,
        loadingBulkAction: false,
        status: 'success'
      }
    case BULK_ACTION_FAIL:
      return {
        ...state,
        loadingBulkAction: false,
        status: 'error',
        error: action.payload
      }

    // ** Section Detail Role
    case DETAIL_ROLE_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_ROLE_SUCCESS:
      return { ...state, loadingDetail: false }
    case DETAIL_ROLE_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }

    // ** Section Update Role
    case UPDATE_ROLE_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_ROLE_SUCCESS:
      const roleUpdate = [...state?.roles]
      const roleUpdateIndex = roleUpdate.findIndex(
        (role) => role.id === action.payload.id
      )
      roleUpdate[roleUpdateIndex] = action.payload

      return {
        ...state,
        roles: roleUpdate,
        loadingUpdate: false,
        status: 'success'
      }
    case UPDATE_ROLE_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        status: 'error',
        error: action.payload
      }

    // ** Section Delete Role
    case DELETE_ROLE_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_ROLE_SUCCESS:
      const roleDelete = [...state.roles]
      const roleDeleteIndex = roleDelete.findIndex(
        (role) => role.id === action.payload.id
      )
      roleDelete.splice(roleDeleteIndex, 1)

      return {
        ...state,
        roles: roleDelete,
        loadingDelete: false,
        status: 'success'
      }
    case DELETE_ROLE_FAIL:
      return {
        ...state,
        loadingDelete: false,
        status: 'error',
        error: action.payload
      }

    // ** Section Reset State Role
    case RESET_STATE_ROLE:
      return {
        ...state,
        loading: false,
        status: '',
        error: ''
      }

    default:
      return state
  }
}

export default roleReducer
